import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the top of the page on every route change.
 *
 * Exceptions:
 *  - When the URL contains a hash anchor (#section), scroll that element
 *    into view instead of forcing the page to the top.
 *  - When React Router navigates with a `state.preserveScroll` flag, leave
 *    the existing scroll position alone.
 */
export const ScrollToTop = () => {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    if (state && state.preserveScroll) return;

    if (hash) {
      // Give the page a tick to render so getElementById can find the target.
      const id = hash.replace(/^#/, "");
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
      };
      // Wait one paint cycle then attempt.
      requestAnimationFrame(tryScroll);
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, state]);

  return null;
};

export default ScrollToTop;
